import { render } from "./trainForm.vue?vue&type=template&id=942a7f04&scoped=true"
import script from "./trainForm.vue?vue&type=script&lang=js"
export * from "./trainForm.vue?vue&type=script&lang=js"

import "./trainForm.vue?vue&type=style&index=0&id=942a7f04&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942a7f04"]])

export default __exports__